import React, { Component, Fragment } from "react";
import { Button, FormGroup, Input, Label, Table } from "reactstrap";

class SocialLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() {
    return (
      <Fragment>
        <div>
          <FormGroup>
            <Label htmlFor="twitter">Twitter</Label>
            <Input
              type="text"
              id="twitter"
              placeholder="Add Twitter Link"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="facebook">Facebook</Label>
            <Input
              type="text"
              id="facebook"
              placeholder="Add Facebook Link"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="gplus">Google+</Label>
            <Input
              type="text"
              id="gplus"
              placeholder="Add Google+ Link"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="linkedin">Linkedin</Label>
            <Input
              type="text"
              id="linkedin"
              placeholder="Add Linkedin Link"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="instagram">Instagram</Label>
            <Input
              type="text"
              id="instagram"
              placeholder="Add Instagram Link"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="quora">Quora</Label>
            <Input
              type="text"
              id="quora"
              placeholder="Add Quora Link"
            />
          </FormGroup>
        </div>
        <div>
          <Button
            className="btn mr-1"
            color="primary">
            Save Changes
            </Button>
          <Button
            className="btn"
            outline
            color="danger">
            Cancel
            </Button>
        </div>
      </Fragment>
    );
  }
}

export default SocialLinks;